import { useState, useCallback } from 'react'

export interface UsePaginationProps {
  totalPages?: number
  page?: number
  setPage?: (page: number | ((page: number) => number)) => void
}

export const usePagination = ({ page, setPage, totalPages = 1 }: UsePaginationProps = {}) => {
  const hasNextPage = page < totalPages
  const hasPrevPage = page > 1

  const onNextPage = useCallback(() => {
    if (hasNextPage) {
      setPage(state => state + 1)
    }
  }, [hasNextPage, setPage])

  const onPrevPage = useCallback(() => {
    if (hasPrevPage) {
      setPage(state => state - 1)
    }
  }, [hasPrevPage, setPage])

  return {
    onNextPage,
    onPrevPage,
    hasNextPage,
    hasPrevPage,
    setPage,
    page,
  }
}

export default usePagination
